import { render, staticRenderFns } from "./SampleConfirmationModal.vue?vue&type=template&id=d977d112&scoped=true&"
import script from "./SampleConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./SampleConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./SampleConfirmationModal.vue?vue&type=style&index=0&id=d977d112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d977d112",
  null
  
)

export default component.exports